const Store = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 11 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.09995 1.14996V0.0999756H9.49985V1.14996H1.09995ZM1.09995 8.49988V5.34991H0.574951V4.29993L1.09995 1.67496H9.49985L10.0248 4.29993V5.34991H9.49985V8.49988H8.44986V5.34991H6.34988V8.49988H1.09995ZM2.14993 7.44989H5.2999V5.34991H2.14993V7.44989ZM1.65119 4.29993H8.9486L8.63361 2.72495H1.96619L1.65119 4.29993Z"
        fill="#AEB9E1"
      />
    </svg>
  );
};

export default Store;
